var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keyword === _vm.element)?_c('aside',[_c('div',{staticClass:"help-text"},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{attrs:{"title":_vm.$t(`buyers.add.form.helpText.${_vm.keyword}.title`)}},[_c('p',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.$t(`buyers.add.form.helpText.${_vm.keyword}.desc`))+" ")])])],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }